import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import styled from 'styled-components';
import Flex from '../../../atoms/Flex';
import { readableNumberParts } from '../../../../helpers/Numbers';
import { color } from '../../../templates/Ui';
const Container = styled(Flex) `
    border: 1px solid #ececec;
    border-radius: 6px;
    margin-bottom: 35px;
    padding: 15px;

    > div:first-child {
        padding: 0;
    }
`;
const SummaryContainer = styled.div `
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px 0;
    font-size: 18px;
    font-weight: 700;
    color: ${props => props.theme.secondary};
`;
const ToggleButton = styled.button `
    background: #ffffff;
    border: 1px solid #cccccc;
    border-radius: 20px;
    color: ${color.paragraph.base};
    font-weight: 700;
    cursor: pointer;
    font-size: 12px;
    margin: 0 auto -28px auto;
    display: flex;
    padding: 5px 10px;
    justify-content: center;

    &:before {
        content: ${props => (props.isOpen ? "'−'" : "'+'")};
        margin-right: 5px;
    }
`;
const CollapsibleContent = styled.div `
    max-height: ${props => (props.isOpen ? '100px' : '0')};
    overflow: hidden;
    transition: max-height 0.3s ease-in-out, margin 0.3s ease-in-out;
    border-top: ${props => (props.isOpen ? '1px solid #ececec' : 'none')};
    margin-top: ${props => (props.isOpen ? '10px' : '0')};

    > div {
        background-color: #ffffff;
        border: none;
        padding: 0;
        display: flex;
        flex-flow: row;
        justify-content: space-between;
        margin: 10px 0;

        &:nth-child(even) {
            background-color: #ffffff;
        }

        > div {
            display: flex;
            flex-basis: auto;
        }

        &:before {
            content: none;
        }
    }
`;
const CollapsibleTotal = ({ summaryTitle, summaryAmount, children, }) => {
    const [isOpen, setIsOpen] = useState(false);
    return (_jsxs(Container, { column: true, children: [_jsxs(SummaryContainer, { children: [_jsx("div", { children: summaryTitle }), _jsx("div", { children: readableNumberParts(summaryAmount, 'EUR').longDecimal })] }), _jsx(CollapsibleContent, { isOpen: isOpen, children: children }), _jsx(ToggleButton, { isOpen: isOpen, onClick: () => setIsOpen(!isOpen), children: isOpen ? 'Details verbergen' : 'Details weergeven' })] }));
};
export default CollapsibleTotal;
